export default {
  models: [],
  model: {},
};
